/********************************** INFO API ********************************/
var shop_api = 'https://clarks-singapore.myshopify.com';

var shop_api_url = shop_api + '/';


var requestUrl = 'https://36c24c23ba08ccf719d3b86d0e2942c0:9dc157967fb8c2d94f25e5a7d6521bb5@clarks-singapore.myshopify.com/admin/api/2019-07/';
var reqUrlNoAuth = shop_api + '/admin/api/2019-07/';
if(shop_url != shop_api ){
    var reqUrlNoAuth = 'https://cors-anywhere.herokuapp.com/'+ shop_api +'/admin/api/2019-07/';
}
var auth = "Basic MzZjMjRjMjNiYTA4Y2NmNzE5ZDNiODZkMGUyOTQyYzA6OWRjMTU3OTY3ZmI4YzJkOTRmMjVlNWE3ZDY1MjFiYjU=";


/***************** GET METAFIELD ID FOR UPDATE ******************************/
function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function getMetafieldId ( request, url , key ){
  
    var metafieldId = false;

    request.open("GET", url ,false );
  
	request.setRequestHeader('Access-Control-Allow-Credentials', true);
          
    request.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
  
    request.setRequestHeader("authorization", auth );
                    
    request.setRequestHeader("Content-Type", "application/json");
    
    request.onload = function() {

            if (request.status >= 200 && request.status < 300) {

                var response = jQuery.parseJSON(request.response);

                var metafields = response.metafields;
              
                metafields.forEach( function( metafield ){

                    if ( metafield.namespace == 'clark' && metafield.key == key ){

                        metafieldId = metafield.id;

                    }
                });
            }
    };
    request.send();

    return metafieldId;
}

/*! jQuery Validation Plugin - v1.13.1 - 10/14/2014
 * http://jqueryvalidation.org/
 * Copyright (c) 2014 JÃ¶rn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.validateDelegate(":submit","click",function(b){c.settings.submitHandler&&(c.submitButton=b.target),a(b.target).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(b.target).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.submit(function(b){function d(){var d,e;return c.settings.submitHandler?(c.submitButton&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),e=c.settings.submitHandler.call(c,c.currentForm,b),c.submitButton&&d.remove(),void 0!==e?e:!1):!0}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c;return a(this[0]).is("form")?b=this.validate().form():(b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b})),b},removeAttrs:function(b){var c={},d=this;return a.each(b.split(/\s/),function(a,b){c[b]=d.attr(b),d.removeAttr(b)}),c},rules:function(b,c){var d,e,f,g,h,i,j=this[0];if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(b,c){i[c]=f[c],delete f[c],"required"===c&&a(j).removeAttr("aria-required")}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g),a(j).attr("aria-required","true")),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}),a.extend(a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){return!!a.trim(""+a(b).val())},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(a,b){(9!==b.which||""!==this.elementValue(a))&&(a.name in this.submitted||a===this.lastElement)&&this.element(a)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date ( ISO ).",number:"Please enter a valid number.",digits:"Please enter only digits.",creditcard:"Please enter a valid credit card number.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){var c=a.data(this[0].form,"validator"),d="on"+b.type.replace(/^validate/,""),e=c.settings;e[d]&&!this.is(e.ignore)&&e[d].call(c,this[0],b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){d[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'] ,[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox']","focusin focusout keyup",b).validateDelegate("select, option, [type='radio'], [type='checkbox']","click",b),this.settings.invalidHandler&&a(this.currentForm).bind("invalid-form.validate",this.settings.invalidHandler),a(this.currentForm).find("[required], [data-rule-required], .required").attr("aria-required","true")},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c=this.clean(b),d=this.validationTargetFor(c),e=!0;return this.lastElement=d,void 0===d?delete this.invalid[c.name]:(this.prepareElement(d),this.currentElements=a(d),e=this.check(d)!==!1,e?delete this.invalid[d.name]:this.invalid[d.name]=!0),a(b).attr("aria-invalid",!e),this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),e},showErrors:function(b){if(b){a.extend(this.errorMap,b),this.errorList=[];for(var c in b)this.errorList.push({message:b[c],element:this.findByName(c)[0]});this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.submitted={},this.lastElement=null,this.prepareForm(),this.hideErrors(),this.elements().removeClass(this.settings.errorClass).removeData("previousValue").removeAttr("aria-invalid")},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled], [readonly]").not(this.settings.ignore).filter(function(){return!this.name&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.name in c||!b.objectLength(a(this).rules())?!1:(c[this.name]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},reset:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([]),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d=a(b),e=b.type;return"radio"===e||"checkbox"===e?a("input[name='"+b.name+"']:checked").val():"number"===e&&"undefined"!=typeof b.validity?b.validity.badInput?!1:d.val():(c=d.val(),"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f=a(b).rules(),g=a.map(f,function(a,b){return b}).length,h=!1,i=this.elementValue(b);for(d in f){e={method:d,parameters:f[d]};try{if(c=a.validator.methods[d].call(this,i,b,e.parameters),"dependency-mismatch"===c&&1===g){h=!0;continue}if(h=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(j){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",j),j}}if(!h)return this.objectLength(f)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a];return void 0},defaultMessage:function(b,c){return this.findDefined(this.customMessage(b.name,c),this.customDataMessage(b,c),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c],"<strong>Warning: No message defined for "+b.name+"</strong>")},formatAndAdd:function(b,c){var d=this.defaultMessage(b,c.method),e=/\$?\{(\d+)\}/g;"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),this.errorList.push({message:d,element:b,method:c.method}),this.errorMap[b.name]=d,this.submitted[b.name]=d},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g=this.errorsFor(b),h=this.idOrName(b),i=a(b).attr("aria-describedby");g.length?(g.removeClass(this.settings.validClass).addClass(this.settings.errorClass),g.html(c)):(g=a("<"+this.settings.errorElement+">").attr("id",h+"-error").addClass(this.settings.errorClass).html(c||""),d=g,this.settings.wrapper&&(d=g.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement(d,a(b)):d.insertAfter(b),g.is("label")?g.attr("for",h):0===g.parents("label[for='"+h+"']").length&&(f=g.attr("id").replace(/(:|\.|\[|\])/g,"\\$1"),i?i.match(new RegExp("\\b"+f+"\\b"))||(i+=" "+f):i=f,a(b).attr("aria-describedby",i),e=this.groups[b.name],e&&a.each(this.groups,function(b,c){c===e&&a("[name='"+b+"']",this.currentForm).attr("aria-describedby",g.attr("id"))}))),!c&&this.settings.success&&(g.text(""),"string"==typeof this.settings.success?g.addClass(this.settings.success):this.settings.success(g,b)),this.toShow=this.toShow.add(g)},errorsFor:function(b){var c=this.idOrName(b),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+d.replace(/\s+/g,", #")),this.errors().filter(e)},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+b+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return this.dependTypes[typeof a]?this.dependTypes[typeof a](a,b):!0},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(a){this.pending[a.name]||(this.pendingRequest++,this.pending[a.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b){return a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,"remote")})}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),/min|max/.test(c)&&(null===g||/number|range|text/.test(g))&&(d=Number(d)),d||0===d?e[c]=d:g===c&&"range"!==g&&(e[c]=!0);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b);for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),void 0!==d&&(e[c]=d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0!==e.param?e.param:!0:delete b[d]}}),a.each(b,function(d,e){b[d]=a.isFunction(e)?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:a.trim(b).length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},creditcard:function(a,b){if(this.optional(b))return"dependency-mismatch";if(/[^0-9 \-]+/.test(a))return!1;var c,d,e=0,f=0,g=!1;if(a=a.replace(/\D/g,""),a.length<13||a.length>19)return!1;for(c=a.length-1;c>=0;c--)d=a.charAt(c),f=parseInt(d,10),g&&(f*=2)>9&&(f-=9),e+=f,g=!g;return e%10===0},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||d>=e},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||c>=a},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.unbind(".validate-equalTo").bind("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d){if(this.optional(c))return"dependency-mismatch";var e,f,g=this.previousValue(c);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),g.originalMessage=this.settings.messages[c.name].remote,this.settings.messages[c.name].remote=g.message,d="string"==typeof d&&{url:d}||d,g.old===b?g.valid:(g.old=b,e=this,this.startRequest(c),f={},f[c.name]=b,a.ajax(a.extend(!0,{url:d,mode:"abort",port:"validate"+c.name,dataType:"json",data:f,context:e.currentForm,success:function(d){var f,h,i,j=d===!0||"true"===d;e.settings.messages[c.name].remote=g.originalMessage,j?(i=e.formSubmitted,e.prepareElement(c),e.formSubmitted=i,e.successList.push(c),delete e.invalid[c.name],e.showErrors()):(f={},h=d||e.defaultMessage(c,"remote"),f[c.name]=g.message=a.isFunction(h)?h(b):h,e.invalid[c.name]=!0,e.showErrors(f)),g.valid=j,e.stopRequest(c,j)}},d)),"pending")}}}),a.format=function(){throw"$.format has been deprecated. Please use $.validator.format instead."};var b,c={};a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)}),a.extend(a.fn,{validateDelegate:function(b,c,d){return this.bind(c,function(c){var e=a(c.target);return e.is(b)?d.apply(e,arguments):void 0})}})});

/************************ Add New Address *************************/
$(".address-page #address_form_new").validate({
        rules: {
          "address[last_name]": "required",
           "address[address1]": "required",
           "address[zip]": {
                required: true,
                minlength: 6,
                maxlength: 6
           },
          "address[phone]": {
                required: true,
                minlength: 8,
                maxlength: 8
           },
           messages: {
             "address[zip]": "Please enter 6 numeric digits for postal code.",
             "address[phone]": "Please enter 8 numeric digits for phone number."
            }
        }
});

$(".form-edit-address form").each(function(){
    var id_form = '#'+ $(this).attr('id');
//     if(defaultAddressId) {
//       $('#' + 'address_default_address_' + defaultAddressId).prop( "checked", true );
//     }
    $(id_form).validate({
        rules: {
          "address[last_name]": "required",
           "address[address1]": "required",
           "address[zip]": {
                required: true,
                minlength: 6,
                maxlength: 6
           },
          "address[phone]": {
                required: true,
                minlength: 8,
                maxlength: 8
           },
           messages: {
             "address[zip]": "Please enter 6 numeric digits for postal code.",
             "address[phone]": "Please enter 8 numeric digits for phone number."
            }
        }
    });
});
/***************************** Share This **********************************/

$(document).ready(function(){
    $('.share-this svg').click(function(){
        $('#popup-subscription').addClass('active'); 
    });
});
$('.share-this #close-popup').click(function(){
    $('.share-this #popup-subscription').removeClass('active');
});


 /*********************** TRACK ORDER **************************************/
if (typeof trackPage !== 'undefined') {

    $('#form-track-order button').click(function(){
        if($('#order_number').val() == ''){
            $('#track-message').html(message_tracking);
        }else{

            var order_number = $('#order_number').val();

            var resUrl = reqUrlNoAuth + 'orders/'+ order_number +'.json';

            var request = new XMLHttpRequest();

            request.open("GET", resUrl ,true );
 

			request.setRequestHeader('Access-Control-Allow-Credentials', true);
      						
            request.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
         
          
            request.setRequestHeader("authorization", auth );
                    
            request.setRequestHeader("Content-Type", "application/json");

            request.onload = function() { 

                if (request.status >= 200 && request.status < 300) {

                    var response = jQuery.parseJSON(request.response);

                    var order = response.order;
                   
                    if( order.fulfillment_status == "fulfilled"){

                        $('#track-message').html('');

                        var fulfillments = order.fulfillments;

                        var tracking_url = '';

                        fulfillments.forEach(function( fulfillment ){

                            tracking_url = fulfillment.tracking_url;

                        });

                        var win = window.open(tracking_url, '_blank');

                        win.focus();

                    }else{

                        $('#track-message').html(tracking_shippment);
                    }
                } else {
                    $('#track-message').html(order_number_wrong);
                  
                    return false;
                }

            };

            request.send(); 
        }
    });
}
 /*********************** CONTACT PAGE **************************************/

if (typeof contactPage !== 'undefined') {

    $('#ContactFormSubject').change(function(){
        var value = $(this).val();
        if(value == ''){
            $('.order-number,.reason, .message').addClass('visually-hidden');
        }
        if(value != ''){
            $('.order-number, .message').removeClass('visually-hidden');
            if( value == 'I want to return an item' ){
                $('.reason').removeClass('visually-hidden');
            }else{
                $('.reason').addClass('visually-hidden');
            }
        }
    });
    $("#contact_form").validate({
        rules: {
           "contact[name]": "required",
           "contact[email]": {
                required: true,
                email: true
           },
           "contact[phone]": {
                required: true,
                minlength: 8,
                maxlength: 8,
                number: true
           },
           "contact[body]": "required",
           "contact[subject]": "required"
        },
        messages: {
            "contact[phone]": "Please enter 8 numeric digits for phone number"
        },
        submitHandler: function(form) {
            if($('#ContactFormOrderNumber').val() == ''){
                $('.order-number').remove();
            }
            $('.grid__item.visually-hidden').remove();
            form.submit();
        }
    });
}
/********************************* LOGIN FORM ******************************/

$("#customer_login").validate({
    rules: {
       "customer[password]": "required",
       "customer[email]": {
            required: true,
            email: true
       }
    },
    submitHandler: function(form) {
        var $this = $("#customer_login");
        var data = $this.serializeArray();
        var checked = false;
        var username = '';
        var password = '';
        data.forEach(function(el){
            if(el.name == 'remember' && el.value == 'on'){
                checked = true;
            }
            if(el.name == 'customer[email]' && el.value != ''){
                username = el.value;
            }
            if(el.name == 'customer[password]' && el.value != ''){
                password = el.value;
            }
        });
        if(checked && username != '' & password != '' ){
            $.cookie('c_remember_me', checked, { expires: 60, path: '/' }); 
            $.cookie('c_username', username, { expires: 60, path: '/' }); 
            $.cookie('c_password', password, { expires: 60, path: '/' }); 
        }
        form.submit();
    }
});
/********************************* REGISTER FORM ******************************/

$(document).ready(function(){
    
    if($('#g-recaptcha').length){//if captcha
      var $newInput = $('<input type="hidden" name="return_to" value="/account" />');
      $newInput.insertBefore($('.shopify-challenge__container input[type="submit"]'));
    }
})


$("#RegisterForm").validate({
    rules: {
       "customer[password]": "required",
       "customer[last_name]": "required",
       "customer[email]": {
            required: true,
            email: true
       }
    },
    submitHandler: function(form) {
        var $this = $("#RegisterForm");
        var data = $this.serializeArray();
        var checked = false;
        var username = '';
        var password = '';
        data.forEach(function(el){
            if(el.name == 'remember' && el.value == 'on'){
                checked = true;
            }
            if(el.name == 'customer[email]' && el.value != ''){
                username = el.value;
            }
            if(el.name == 'customer[password]' && el.value != ''){
                password = el.value;
            }
        });
        if(checked && username != '' & password != '' ){
            $.cookie('c_remember_me', checked, { expires: 60, path: '/' }); 
            $.cookie('c_username', username, { expires: 60, path: '/' }); 
            $.cookie('c_password', password, { expires: 60, path: '/' }); 
        }
        form.submit();
      
    }
});
/********************************* AS GUESt  ******************************/

$("#customer_login_guest").validate({
    rules: {
       "customer[email]": {
            required: true,
            email: true
       }
    },
    submitHandler: function(form) {
        var email = $('#RegisterFormGuest-email').val();
        var checkoutUrl = $('input[name="checkout_url"]').val() + '&email=' + email;
        $('input[name="checkout_url"]').val(checkoutUrl);
        form.submit();
     }
   
});

/************************************** Account *****************************/

$('.show_full').on('click',function(){
    if($(this).hasClass('show_items')){
        $(this).removeClass('show_items');
        $(this).closest('.item').find('.hide_m').addClass('hide').removeClass('hide_m');
    }else{
        $(this).addClass('show_items');
        $(this).closest('.item').find('.hide').addClass('hide_m').removeClass('hide');
    }
    
});

if (customer.customer_id != null){
  
    // GET NOTE 
    var customerId = customer.customer_id;

    var resUrl = reqUrlNoAuth + 'customers/'+ customerId +'.json';

    var resUrlMetas = reqUrlNoAuth + 'customers/'+ customerId +'/metafields.json';

    
     /*************** FORM CHANGE PASS ****************************/

    if (typeof changePassPage !== 'undefined') {
		
        var request = new XMLHttpRequest();

        request.open("GET", resUrl ,false );
      	
      	request.setRequestHeader('Access-Control-Allow-Credentials', true);
      	request.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
      
        request.setRequestHeader("authorization", auth );
                
        request.setRequestHeader("Content-Type", "application/json");

        request.onload = function() { 

            if (request.status >= 200 && request.status < 300) {
                var response = jQuery.parseJSON(request.response);
                var note = response.customer.note;
                $('#customer_notes').html(note);
            }

        };

        request.send();

        $("#customer_edit").submit(function(e) {
            e.preventDefault();
        }).validate({
            rules: {
               "customer[new_password]": "required",
               confirm_new_password: {
                    required: true,
                    equalTo: "#customer_new_password"
                },
            },
            submitHandler: function(form) {
            var password = $('#customer_new_password').val();
            var data = {
                  "customer": {
                    "first_name": customer.firstName,
                    "last_name": customer.lastName,
                    "email": customer.email,
                    "phone": customer.phone,
                    "verified_email": true,
                    "addresses": null,
                    "password": password,
                    "password_confirmation": password,
                    "send_email_welcome": false,
                    "note": $('#customer_notes').html()
                  }
                };
                var json = JSON.stringify(data);
                var request2 = new XMLHttpRequest();

                request2.open("PUT", resUrl,true );
              
				request2.setRequestHeader('Access-Control-Allow-Credentials', true);
              
      			request2.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
              
              
                request2.setRequestHeader("authorization", auth );
                
                request2.setRequestHeader("Content-Type", "application/json");

                request2.onload = function() { 

                    if (request2.status >= 200 && request2.status < 300) {
                       $('#popup-subscription').show(); 
                    }
                };

                request2.send(json);

                return false;
            }
        });
        $('#close-popup').click(function(){
            $('#popup-subscription').hide();
            window.location.href = window.location.href ;
        });
    }

    /*************** FORM EDIT ****************************/
    // Create metafields
    if(customer.birth_day == null){
            var data = {
                "customer": {
                "id": customerId,
                "metafields": [
                  {
                    "key": "gender",
                    "value": "male",
                    "value_type": "string",
                    "namespace": "clark"
                  },
                  {
                    "key": "birth_day",
                    "value": "1/1/1920",
                    "value_type": "string",
                    "namespace": "clark"
                  }
                ]
              }
            };

            var res = new XMLHttpRequest();

            var json = JSON.stringify(data);

            res.open("PUT", resUrl,true );
          
          	res.setRequestHeader('Access-Control-Allow-Credentials', true);
          
      		res.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
          
            res.setRequestHeader("authorization", auth );
            
            res.setRequestHeader("Content-Type", "application/json");

            res.send(json); 
        }
  
    if (typeof editPage !== 'undefined') {
      
      var newReg = getUrlParameter('new');
      
      if($('#popup-register-success') && newReg ==1) {
        $('#popup-register-success').show();
      }
      
        $('#popup-register-success #close-popup').click(function(){
            $('#popup-register-success').hide();
        });
        
        $("#customer_edit_info").submit(function(e) {

            e.preventDefault();

        }).validate({
            rules: {
                "address[phone]": {
                required: true,
                minlength: 8,
                maxlength: 8,
                number: true
               },
               "address[last_name]": "required"
            },
            messages: {
                "address[phone]": "Please enter 8 numeric digits for phone number"
            },
            submitHandler: function(form) {
                $('#customer_edit').addClass('is-loading');
                var request;
              
                if (window.XMLHttpRequest) {
                  // code for modern browsers
                   request = new XMLHttpRequest();
                } else {
                  // code for old IE browsers
                  request = new ActiveXObject("Microsoft.XMLHTTP");
                }

                var birth_day = $('#date').val() + '/' + $('#month').val() + '/' + $('#year').val();
                
                if($('#customer_edit-gender-male').prop('checked')){
                    var gender = $('#customer_edit-gender-male').val();
                }

                if($('#customer_edit-gender-female').prop('checked')){
                    var gender = $('#customer_edit-gender-female').val();
                }

                var lastName = $('.last_name').val();
                var firstName = $('.first_name').val();
                var phone = '+65' + $('#phone').val();

                var data_customer = {
                    "customer": {
                        "id": customerId,
                        "email": customer.email,
                        "last_name": lastName,
                        "first_name": firstName,
                        "phone": phone  
                    }
                };

                var json_customer = JSON.stringify(data_customer);


                request.open("PUT", resUrl.replace(/https:\/\/[^:]*:([^@]*)@/gm,"https://") ,true);
              
				request.setRequestHeader('Access-Control-Allow-Credentials', true);
              
      			request.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
              
                request.setRequestHeader("authorization", auth );

                request.setRequestHeader("Content-Type", "application/json");

                request.onload = function() { 

                    if (request.status >= 200 && request.status < 300) {

                        // UPDATE GENDER 
                      
                            var metaIDGender = getMetafieldId( request, resUrlMetas.replace(/https:\/\/[^:]*:([^@]*)@/gm,"https://") , 'gender' );
                      		
                            resUrl = reqUrlNoAuth.replace(/https:\/\/[^:]*:([^@]*)@/gm,"https://") + 'customers/'+ customerId + '/metafields/' + metaIDGender + '.json';
							
                            var data_gender = {
                                "metafield": {
                                "id": metaIDGender,
                                "value": gender,
                                "value_type": "string"
                              }
                            };

                            var json_gender = JSON.stringify(data_gender);

                            var request2;

                            if (window.XMLHttpRequest) {
                                // code for modern browsers
                                request2 = new XMLHttpRequest();
                             } else {
                                // code for old IE browsers
                                request2 = new ActiveXObject("Microsoft.XMLHTTP");
                            }

                            request2.open("PUT", resUrl ,true );
							
                      		request2.setRequestHeader('Access-Control-Allow-Credentials', true);
      						
                      		request2.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
                      
                            request2.setRequestHeader("authorization", auth );
                      
                            request2.setRequestHeader("Content-Type", "application/json");

                            request2.onload = function() { 

                                if (request2.status >= 200 && request2.status < 300) {

                                     // UPDATE BIRTH DAY 

                                    var metaIDBirthDay = getMetafieldId( request2, resUrlMetas.replace(/https:\/\/[^:]*:([^@]*)@/gm,"https://") , 'birth_day' );

                                    resUrl = reqUrlNoAuth + 'customers/'+ customerId + '/metafields/' + metaIDBirthDay + '.json';

                                    var data_birthday = {
                                        "metafield": {
                                        "id": metaIDBirthDay,
                                        "value": birth_day,
                                        "value_type": "string"
                                      }
                                    };
                                    var json_birthday = JSON.stringify(data_birthday);
                                  
                                    var request3;

                                    if (window.XMLHttpRequest) {
                                        // code for modern browsers
                                        request3 = new XMLHttpRequest();
                                    } else {
                                        // code for old IE browsers
                                        request3 = new ActiveXObject("Microsoft.XMLHTTP");
                                    }

                                    request3.open("PUT", resUrl,true );
                                  
									request3.setRequestHeader('Access-Control-Allow-Credentials', true);
      						
                      				request3.setRequestHeader('Access-Control-Allow-Origin',shop_api_url);
                      
                           
                                    request3.setRequestHeader("authorization", auth );
                                    
                                    request3.setRequestHeader("Content-Type", "application/json");
                                    
                                    request3.onload = function() { 

                                        if (request3.status >= 200 && request3.status < 300) {

                                            $('#popup-subscription').css("display", "block");
                                            $('#customer_edit').removeClass('is-loading');

                                        }
                                    }
                                    request3.send(json_birthday);
                                }
                            }
                            request2.send(json_gender);
                       
                    }else{
                        $('#popup-subscription-error').css("display", "block");
                      $('#customer_edit').removeClass('is-loading');
                    }
                };

                request.send(json_customer);
            }

        });
        $('#close-popup').click(function(){
            $('#popup-subscription').hide();
            window.location.href = window.location.href ;
        });
        $('#close-popup-error').click(function(){
            $('#popup-subscription-error').hide();
        });
    }
    /*********************** FOR SUBSCRIBE PAGE ************************************/
    if (typeof subscribePage !== 'undefined') {

        var request = new XMLHttpRequest();

        request.open("GET", resUrl + '?_=' + new Date().getTime() ,true );

		request.setRequestHeader('Access-Control-Allow-Credentials', true);
          
      	request.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
      
        request.setRequestHeader("authorization", auth );
                
        request.setRequestHeader("Content-Type", "application/json");

        request.onload = function() { 

            if (request.status >= 200 && request.status < 300) {

                var response = jQuery.parseJSON(request.response);

                var note = response.customer.note;

                $('#customer_notes').html(note);

                notes = note.split('\n');
        

                if(notes.length > 0 && note != '' && note.indexOf('gender_sub') != -1 ){

                    if( customer.accepts_marketing ) {

                        $('.subcribe-account .contact-form input[type="checkbox"]').prop('checked' , false );

                        notes.forEach(function( not ){

                            var item = not.split(':');

                            var value = $.trim ( item[1]);

                            if( item[0] ==  'gender_sub'){

                                value = value.split(',');

                                value.forEach(function( e ){

                                    $('#'+ e).prop('checked',true);

                                });
                            }
                        });
                    }
                }
            }

        };

        request.send(); 

        if( !customer.accepts_marketing ) {

            $(".subcribe-account .contact-form").submit(function(e) {
                e.preventDefault();
            }).validate({
                rules: {
                   agree: "required"
                },
                messages: {
                    agree: "Please accept our policy"
                },
                submitHandler: function(form) {
                    var women = $('input[name="contact[womens]"]');
                    var men =  $('input[name="contact[mens]"]');
                    var notes = '';
                    if(women.prop('checked')){
                        if(notes == ''){
                            notes += women.val();
                        }else{
                            notes += ',';
                            notes += women.val();
                        }
                    }
                    if(men.prop('checked')){
                        if(notes == ''){
                            notes += men.val();
                        }else{
                            notes += ',';
                            notes += men.val();
                        }
                    }
                    var noteLast = 'gender_sub: ' + notes;

                    var data = {
                        "customer": {
                        "id": customerId,
                        "email": customer.email,
                        "note": noteLast,
                        "accepts_marketing": true,
                        "tags": "prospect,newsletter"
                      }
                    };

                    var json = JSON.stringify(data);
                  
                  var request2 = new XMLHttpRequest();

                    request2.open("PUT", resUrl,true );
                  
					request2.setRequestHeader('Access-Control-Allow-Credentials', true);
          
      				request2.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
                 
                  
                    request2.setRequestHeader("authorization", auth );
                    
                    request2.setRequestHeader("Content-Type", "application/json");
                  
                    request2.onload = function() {
                        if (request2.status >= 200 && request2.status < 300) {
                            $('#popup-subscription').show();
                        }
                    };
                    request2.send(json);
                }
            });
        }else{

            $(".subcribe-account .contact-form button").click(function(){

                var women = $('input[name="contact[womens]"]');
                var men =  $('input[name="contact[mens]"]');
                var notes = '';
                if(women.prop('checked')){
                    if(notes == ''){
                        notes += women.val();
                    }else{
                        notes += ',';
                        notes += women.val();
                    }
                }
                if(men.prop('checked')){
                    if(notes == ''){
                        notes += men.val();
                    }else{
                        notes += ',';
                        notes += men.val();
                    }
                }

                params = 'gender_sub: ' + notes;

                var data = {
                    "customer": {
                    "id": customerId,
                    "email": customer.email,
                    "note": params
                  }
                };
                  var request2 = new XMLHttpRequest();

                var json = JSON.stringify(data);

                request2.open("PUT", resUrl,true );
              
				request2.setRequestHeader('Access-Control-Allow-Credentials', true);
          
      			request2.setRequestHeader('Access-Control-Allow-Origin', shop_api_url);
                 
              
                request2.setRequestHeader("authorization", auth );
                
                request2.setRequestHeader("Content-Type", "application/json");

                request2.onload = function() {

                    if (request2.status >= 200 && request2.status < 300) {

                        $('#popup-subscription').show();
                    }

                };

                request2.send(json); 
            });
        }
        $('#close-popup').click(function(){
            $('#popup-subscription').hide();
            window.location.href = '/pages/newsletter' ;
        });
    }
}
/************************************** REVIEW *****************************/

$("body").on('DOMSubtreeModified', "#shopify-product-reviews", function() {
    $('.spr-summary-actions').remove();
    if(customer.show_form && customer.customer_id != null && customer.order_count > 0){
        $('.spr-reviews').remove();
        $('.spr-header').remove();
        $('.spr-form-input-email').val( customer.email );
        $('.spr-form-contact-email').hide();
        $('.spr-form-review-title .spr-form-input-text').val('Clark');
        $('.spr-form-review-title').hide();
    }else{
        $('.spr-form').remove();
    }
    
});


/**************************************  DISCOUNT  ************************************************/ 
$(document).on('click','#CartDrawer .discount-form .btn',function(e){
        $('#CartDrawer').addClass('is-loading');
        e.preventDefault();

        var discount = $('input[name="discount"]').val();

        if( discount == '' ) {
            discount  = '%20';
        }

            //$('.discount-note').show();

            var desUrl = shop_url + '/checkout?discount=' + discount ;

            var request = new XMLHttpRequest();

            request.open("GET", desUrl, true );
  			
  			request.withCredentials = true;

            request.onload = function() { 
                
                if (request.status >= 200 && request.status < 300) {

                    var response = $(request.response);

                    var orderSummay = response.find('.order-summary');

                    orderSummay = orderSummay[0];

                    $('#checkout').html($(orderSummay).html()); 

                    var checkoutUrl = response.find('.edit_checkout');

                    checkoutUrl = $(checkoutUrl[0]).attr('action') + '?step=contact_information';

                    $('#checkoutUrl').html(checkoutUrl);

                    if(typeof $('#checkout #error-for-reduction_code').html() !== 'undefined'){

                        $('.discount-note').show();
                        $('.grid-discount').hide();

                        var desUrlRemove = shop_url + '/checkout?discount=%20';
                        

                        var requestRemove = new XMLHttpRequest();

                        requestRemove.open("GET", desUrlRemove, false );
                      
                        requestRemove.onload = function() { 
  
                          if (requestRemove.status >= 200 && requestRemove.status < 300) {
                          
                            var responseRemove = $(requestRemove.response);

                            var orderSummayRemove = responseRemove.find('.order-summary');
                            
                            orderSummayRemove = orderSummayRemove[0];
                            $('#checkout').html($(orderSummayRemove).html()); 

                            var checkoutUrl = responseRemove.find('.edit_checkout');

                            checkoutUrl = $(checkoutUrl[0]).attr('action') + '?step=contact_information';

                            $('#checkoutUrl').html(checkoutUrl);
                            
                            //Remove shipping on cart
                            var shippingPrice = $('.total-line--shipping .total-line__price .order-summary__emphasis').attr('data-checkout-total-shipping-target');
                            var sbtotalPrice = $('#checkout .total-line-table__footer .total-line__price .payment-due__price').attr('data-checkout-payment-due-target');

                            if(parseInt(shippingPrice)>0){
                                sbtotalPrice = parseInt(sbtotalPrice) - parseInt(shippingPrice);
                            }
                            var totalPriceFormat = theme.Currency.formatMoney(sbtotalPrice,theme.settings.moneyFormat);

                            $('#checkout .total-line-table__footer .total-line__price .payment-due__price').html(totalPriceFormat);

                            var totalPrice = $('#checkout .total-line-table__footer .total-line__price').html();
                    
                            $('.cart-ajax-total .ajaxcart__total').html( totalPrice );

                            $('.cart-total .ajaxcart__total').html(totalPrice);
                          
                          }
                        }
                        
                        requestRemove.send();

                    }else{
                        var moneyFormat = theme.settings.moneyFormat;

                        $('.discount-note').hide();

                        var discounts = $('#checkout .product__description .reduction-code__text');

                        var discountTotalPrice = 0;
                        var discountCode = '';

                        if(typeof $('#checkout .total-line--reduction').html() !== 'undefined' ){
                            discountTotalPrice = $('#checkout .total-line--reduction .order-summary__emphasis').data('checkout-discount-amount-target');
                            discountCode  = $('#checkout .total-line--reduction .reduction-code__text').html();
                        }else{
                            if(typeof discounts.html()!== 'undefined'){
                                discountCode = $('#checkout .tags-list .reduction-code__text').html();
                                discounts.each(function( ){
                                    var discount = $(this).html().trim().split(' ');
                                    var price = discount[1];
                                    price = price.replace('(-','').replace(')','');
                                    discountTotalPrice +=  parseInt(price.replace(/\D/g,''));
                                }); 
                            }   
                        }  
                        if(discountTotalPrice > 0){
                            var total = discountTotalPrice / 100;
                            var moneyFormat = theme.settings.moneyFormat;
                            moneyFormat= moneyFormat.replace(/\{\{amount\}\}/g,total).replace(/\{\{amount_no_decimals\}\}/g,total);

                            var discountPrice =  $('.ajaxcart___discount').html('-' + moneyFormat );

                            $('.grid-discount').show();
                            $('.ajaxcart__discount__label span').html(discountCode);
                            $('.js-form-discount').val(discountCode);

                        }else{
                            $('.grid-discount').hide();
                        }
						//Remove shipping on cart
                        var shippingPrice = $('.total-line--shipping .total-line__price .order-summary__emphasis').attr('data-checkout-total-shipping-target');
                        var sbtotalPrice = $('#checkout .total-line-table__footer .total-line__price .payment-due__price').attr('data-checkout-payment-due-target');

                        if(parseInt(shippingPrice)>0){
                            sbtotalPrice = parseInt(sbtotalPrice) - parseInt(shippingPrice);
                        }
                        var totalPriceFormat = theme.Currency.formatMoney(sbtotalPrice,theme.settings.moneyFormat);

                        $('#checkout .total-line-table__footer .total-line__price .payment-due__price').html(totalPriceFormat);
                        
                         var totalPrice = $('#checkout .total-line-table__footer .total-line__price').html();
                    
                        $('.cart-ajax-total .ajaxcart__total').html( totalPrice );

                        $('.cart-total .ajaxcart__total').html(totalPrice);
                    }
                    setTimeout(function(){ $('#CartDrawer').removeClass('is-loading'); }, 1000);
                    
                }
            };
            request.send();
});
$(document).on('submit','form.cart.ajaxcart' ,function(e){
    e.preventDefault();
    let checkout_url = $('#checkoutUrl').html();
    if(checkout_url.indexOf('undefined?step=contact_information') >= 0) {
        checkout_url = '/checkout/?step=contact_information';
    }

    if(customer.customer_id != null){
        window.location.href = shop_url + checkout_url;
    }else{
        window.location.href = '/account/login/?checkout_url=' + encodeURIComponent(shop_url + checkout_url);
    }
    
});
 
/********************************* WISHLIST *************************************/

// IN CASE: EXIST A CUSTOMER 
if( customer.customer_id != null ){
   $('#heading-breadcrumbs .col-md-6').prepend(customer.template);
}
$(document).on('click','#bookmarkit',function(){
    $('.clarkwishlist').addClass('active');
    var template = $('.message_w').prop("outerHTML");
    $('#wishlist_message').html(template);
});
$(document).on('click','.message_w .close-popup',function(){
    $('.clarkwishlist').removeClass('active');
});
$(document).on('click','.btn-wislist .message_w .close-popup',function(){
    $(this).closest('.btn-wislist').removeClass('active');
});
function showMessage(elem){
    $(elem).closest('.btn-wislist').addClass('active');
    var template = $('.message_w').prop("outerHTML");
    $(elem).next().html(template);
}
/********************************* REMEMBER ME  *************************************/


if(customer.customer_id != null ){
    if(!$.cookie('c_remember_me') && $.cookie('c_remember_me') != undefined ){
        $.cookie('c_username', '');
        $.cookie('c_password','');
    }
}
if(customer.customer_id == null ){
    if($.cookie('c_remember_me') && $.cookie('c_remember_me') != undefined ){
        $('#customer_login #CustomerEmail').val($.cookie('c_username'));
        $('#customer_login #CustomerPassword').val($.cookie('c_password'));
        $('#customer_login #rememberMe').prop('checked', true);
    }
}
/********************************* COOKIES  *************************************/

/*!
 * ihavecookies.js
 */
!function(t){t.fn.ihavecookies=function(n){var r=t(this),o=t.extend({title:"Cookies & Privacy",message:"Cookies enable you to use shopping carts and to personalize your experience on our sites, tell us which parts of our websites people have visited, help us measure the effectiveness of ads and web searches, and give us insights into user behavior so we can improve our communications and products.",link:"/privacy-policy",delay:2e3,expires:30,onAccept:function(){},uncheckBoxes:!1},n),s=i("cookieControl");if(s)e(o.expires);else{var a='<div id="gdpr-cookie-message"><div class="gdpr-cookie-message__container"><p>'+o.message+'</p><p><a href="'+o.link+'">More information</a> <button class="btn btn--no-min-width" id="gdpr-cookie-accept" type="button">Accept</button></p></div></div>';setTimeout(function(){t(r).append(a),t("#gdpr-cookie-message").hide().fadeIn("slow")},o.delay),t("body").on("click","#gdpr-cookie-accept",function(){e(o.expires),o.onAccept.call(this)})}o.uncheckBoxes===!0&&t('input[type="checkbox"].ihavecookies').prop("checked",!1)};var e=function(e){n("cookieControl",!0,e),t("#gdpr-cookie-message").fadeOut("fast",function(){t(this).remove()})},n=function(t,e,n){var r=new Date;r.setTime(r.getTime()+24*n*60*60*1e3);var o="expires="+r.toUTCString();return document.cookie=t+"="+e+";"+o+";path=/",i(t)},i=function(t){for(var e=t+"=",n=decodeURIComponent(document.cookie),i=n.split(";"),r=0;r<i.length;r++){for(var o=i[r];" "==o.charAt(0);)o=o.substring(1);if(0===o.indexOf(e))return o.substring(e.length,o.length)}return!1}}(jQuery);

if (window.theme.cookieBanner.enabled === 'true') {
  $(document).ready(function buildCookieBanner() {
    $('body').ihavecookies({
      title: '',
      message: window.theme.cookieBanner.message,
      acceptBtnLabel: 'X',
      delay: 0,
      expires: 30,
      link: '',
      moreInfoLabel: '',
      onAccept: function acceptCookies() {
        $('body').removeClass('has-cookie-banner');
        $('body').css('padding-bottom', '0');
      },
      uncheckBoxes: true
    });
  });
}

$(function() {
  $(document).ready(function() {
    if ($('body').hasClass('has-cookie-banner')) {
      var cookieHeight = $('#gdpr-cookie-message').outerHeight();
      $('body').css('padding-bottom', cookieHeight);
      $(window).resize(function() {
        var cookieHeight = $('#gdpr-cookie-message').outerHeight();
        $('body').css('padding-bottom', cookieHeight);
      });
    }
  });
});

/**
 * Push page content down if cookie banner is visible
 *
 */

(function cookieBannerPosition() {
  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    var i;
    var c;
    for (i = 0; i < ca.length; i += 1) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  if (!getCookie('cookieControl')) {
    $('body').addClass('has-cookie-banner');
  }
})();

